module.exports = __webpack_public_path__ + "img/complete.821ee034.jpg";